export default {
  main: '#006B4A',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#0064B4A',
  entryBackground: '#006B4A',
  menuBackgroundColor: '#006B4A',
  menuTextColor: '#ffffff',
};
